import be from 'react-intl/locale-data/be'
import bg from 'react-intl/locale-data/bg'
import cs from 'react-intl/locale-data/cs'
import da from 'react-intl/locale-data/da'
import de from 'react-intl/locale-data/de'
import el from 'react-intl/locale-data/el'
import en from 'react-intl/locale-data/en'
import es from 'react-intl/locale-data/es'
import et from 'react-intl/locale-data/et'
import fi from 'react-intl/locale-data/fi'
import fil from 'react-intl/locale-data/fil'
import fr from 'react-intl/locale-data/fr'
import hr from 'react-intl/locale-data/hr'
import hu from 'react-intl/locale-data/hu'
import id from 'react-intl/locale-data/id'
import it from 'react-intl/locale-data/it'
import ja from 'react-intl/locale-data/ja'
import kk from 'react-intl/locale-data/kk'
import ko from 'react-intl/locale-data/ko'
import lt from 'react-intl/locale-data/lt'
import lv from 'react-intl/locale-data/lv'
import ms from 'react-intl/locale-data/ms'
import nl from 'react-intl/locale-data/nl'
import no from 'react-intl/locale-data/no'
import pl from 'react-intl/locale-data/pl'
import pt from 'react-intl/locale-data/pt'
import ro from 'react-intl/locale-data/ro'
import ru from 'react-intl/locale-data/ru'
import sr from 'react-intl/locale-data/sr'
import sv from 'react-intl/locale-data/sv'
import th from 'react-intl/locale-data/th'
import tr from 'react-intl/locale-data/tr'
import uk from 'react-intl/locale-data/uk'
import vi from 'react-intl/locale-data/vi'
import zh from 'react-intl/locale-data/zh'

export const localeDataHash = {
    be,
    bg,
    cs,
    da,
    de,
    el,
    en,
    es,
    'es-AR': es,
    'es-ar': es,
    'es-MX': es,
    'es-mx': es,
    et,
    fi,
    fil,
    fr,
    hr,
    hu,
    id,
    it,
    ja,
    kk,
    ko,
    lt,
    lv,
    ms,
    nl,
    no,
    pl,
    pt,
    'pt-BR': pt,
    'pt-br': pt,
    ro,
    ru,
    sr,
    sv,
    th,
    tr,
    uk,
    vi,
    'zh-CN': zh,
    'zh-cn': zh,
    'zh-SG': zh,
    'zh-sg': zh,
    'zh-TW': zh,
    'zh-tw': zh,
}

export const DEFAULT_LANGUAGE = 'en'

export const getCurrentLanguage = () => {
    const navigatorLanguages = [window.navigator.language, ...(window.navigator.languages || [])]
        .map((language) => language && language.toLowerCase().replace('_', '-'))
    const supportedLanguages = Object.keys(localeDataHash)
    const languageCode = navigatorLanguages.find((language) => {
        return (supportedLanguages.includes(language))
    })
    return languageCode || DEFAULT_LANGUAGE
}

export const isChineseLanguage = () => getCurrentLanguage().startsWith('zh')



// WEBPACK FOOTER //
// ../node_modules/react-mt-bootstrap/lib/helpers/locale.js